import * as Yup from "yup"

import { messages } from "utils/messages"

const schema = Yup.object({
  name: Yup.string().max(120, messages.max_chars(120)).required(messages.required),
})

export default schema
